module.exports = __webpack_public_path__ + "img/archive-hero-small.3af6dbde.webp";